<template>
  <button
    @click="emitClick()"
    class="StandardSmallBorderedButton"
    :class="[{ disabled: disabled, fluid: fluid }, color]"
  >
    {{ title }}
  </button>
</template>

<script>
export default {
  name: 'StandardSmallSolidButton',
  props: ['title', 'disabled', 'fluid', 'color'],
  data() {
    return {}
  },
  computed: {},
  methods: {
    emitClick() {
      if (!this.disabled) {
        this.$emit('click')
      }
    },
  },
  mounted() {},
  beforeCreate() {},
  destroyed() {},
}
</script>

<style lang="scss" scoped>
.StandardSmallBorderedButton {
  background-color: $twilight;
  border: 1px solid $twilight;
  color: white;
  height: 24px;
  font-size: 12px;
  @include Gilroy-Bold;
  transition: 0.3s;
  letter-spacing: 0.16px;
  cursor: pointer;
  width: 100%;

  &.fluid {
    width: auto;
    padding: 0 8px;
  }

  &.disabled {
    border-color: $fog;
    color: white;
    background: $fog;
    cursor: default;

    &:hover {
      border-color: $fog;
      background-color: $fog;
    }
  }

  &:hover {
    border-color: $twilightshade;
    background-color: $twilightshade;
  }

  &.midnight {
    background-color: $midnight;
    border: 1px solid $midnight;
    color: white;

    &:hover {
      border-color: black;
      background-color: black;
    }
  }
}

@media (min-width: 992px) {
  button {
    &.StandardSmallBorderedButton {
      @include Gilroy-Bold;
    }
  }
}
</style>
